var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"bdb"},[_c('el-col',{attrs:{"sm":{ span: 4, push: 2 },"xs":{ span: 24 }}},[_c('div',{staticClass:"comp-header_logo",on:{"click":function($event){return _vm.$router.push({ name: 'index' })}}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }